import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function GlobalsAPI(): BringozApi {
  return {
    base: `/settings/globals`,
    infiniteScroll: {
      address: `/settings/globals`,
      cmd: 'GET'
    }
  }
}
angular
  .module('bringoz.admin.site-preferences')
  .factory('GlobalsAPI', GlobalsAPI);
